"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekHeader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const date_fns_1 = require("date-fns");
const Css_1 = require("../../../Css");
function WeekHeader() {
    const start = (0, date_fns_1.startOfWeek)(new Date());
    const days = [];
    for (let i = 0; i < 7; i++) {
        days.push((0, date_fns_1.addDays)(start, i));
    }
    // Copies the existing structure and classes defined by React-Day-Picker. Adds in Beam styling and formatting.
    return ((0, jsx_runtime_1.jsx)("thead", { className: "rdp-head", children: (0, jsx_runtime_1.jsx)("tr", { className: "rdp-head_row", children: days.map((day) => ((0, jsx_runtime_1.jsxs)("th", { scope: "col", css: Css_1.Css.p1.pbPx(12).xs.gray400.$, children: [(0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", children: (0, date_fns_1.format)(day, "EEEEE") }), (0, jsx_runtime_1.jsx)("span", { className: "rdp-vhidden", children: (0, date_fns_1.format)(day, "EEEE") })] }, (0, date_fns_1.format)(day, "EEEE")))) }) }));
}
exports.WeekHeader = WeekHeader;
